define('app/views/vue/vue-starter',['Vue', 'vue', 'vuex', 'moment', 'es6-promises', 'es6-promises-auto'],
    function (Vue, vue, vuex, moment) {
        var localStrings = app.localization.spaBooking.packageBooking;
        var customization = app.customization.spaBooking
        var staffPickRequired = false
        return function (urlConfig) {
            Vue.use(vuex);
            require(['helpers'], function (helpers) {
                helpers.configFromUrl = urlConfig;
            })
            Vue.mixin({
                data: function () {
                    return {
                        localStrings: localStrings,
                        localization: app.localization,
                        customization: customization,
                        singleBookingMode: localStrings.configuration.singleBookingMode,
                        currencyPrefix: app.localization.general.currencyPrefix,
                        staffPickRequired: staffPickRequired
                    }
                },
                methods: {
                    a11yKeyDown: function (e, handlers) {
                        switch (e.keyCode) {
                            case 38:
                                handlers.up && handlers.up();
                                break;
                            case 40:
                                handlers.down && handlers.down();
                                break;
                            case 37:
                                handlers.left && handlers.left();
                                break;
                            case 39:
                                handlers.right && handlers.right();
                                break;
                            case 13:
                                handlers.enter && handlers.enter();
                                break;
                            case 9:
                                if (e.shiftKey) {
                                    handlers.shiftTab && handlers.shiftTab();
                                } else handlers.tab && handlers.tab();
                                break;
                            case 32:
                                handlers.space && handlers.space();
                            case 27:
                                handlers.escape && handlers.escape();
                        }
                    },
                    verifyAge: function (product, customerID) {
                        // checking if user is able to book a service based on age restriction. This function checks if user age is valid, whether it requires a date pikcer or not. It also store entries into scheduleBtnValidity state in the store that keeps track of eligibility of the selected user and Error messages

                        var services = [],
                            result = [],
                            isValid = true,
                            requireDatePicker = false,
                            self = this
                        services = product.PackageItems ? product.PackageItems.PackageItem : [product]

                        if ((_.keys(self.users).length == 1))
                            customerID = _.keys(self.users)[0]

                        var guestProfile = self.$store.state.guestProfiles[customerID] || {}
                
                        var userAge = moment().diff(guestProfile.DateOfBirth, 'years');
                        _.each(services, function (item, index) {
                            if (!app.data.userLoggedIn && (item.MinAge || item.MaxAge))  isValid = false
                           else {
                                if (guestProfile.DateOfBirth && !isNaN(userAge)) {
                                    if ((item.MinAge && userAge < item.MinAge) || (item.MaxAge && userAge > item.MaxAge)) isValid = false
                                }
                                //if user birthdate is not present and item min and max is not set, that means self item has no age restrictions so birthdate check not needed
                                else if (!guestProfile.birthdate && (item.MinAge || item.MaxAge)) {
                                    isValid = false
                                    requireDatePicker = true
                                }
                                result.push({
                                    isValid: isValid,
                                    requireDatePicker: requireDatePicker,
                                    serviceIndex: index //to use some of its field for error messages
                                })
                            }
                        })
                        for (var i = 0; i < result.length; i++) {
                            if (!result[i].isValid) {
                            
                                self.$store.commit('setScheduleBtnValidity', {
                                    id: customerID,
                                    status: result[i].isValid,
                                    action: "add",
                                    isPackage: !!product.PackageItems
                                })
                                if(!app.data.userLoggedIn) return result[i];
                                guestProfile.requireDatePicker = result[i].requireDatePicker
                                var minAge = services[result[i].serviceIndex].MinAge
                                var MaxAge = services[result[i].serviceIndex].MaxAge
                                !result[i].requireDatePicker ? self.$store.commit('setAgeRestrictionErrMessages', {
                                        id: customerID,
                                        message: guestProfile['Name']['FirstName'] + " "+localStrings.ageRestriction.notMeetingAgeReqPreText + " " + (minAge && userAge < minAge ?
                                            "min:" + minAge + "" : "") + (MaxAge && userAge > MaxAge ? " max:" + MaxAge + "" : "")
                                    }) : guestProfile.CanEdit == "N" && result[i].requireDatePicker ?
                                    self.$store.commit('setAgeRestrictionErrMessages', {
                                        id: customerID,
                                        message: localStrings.ageRestriction.cannotEditUserDobTextOne + " " + guestProfile.Name.FirstName + " " +localStrings.ageRestriction.cannotEditUserDobTextTwo
                                    }) : ''
                                return result[i];
                            }
                        }
                        guestProfile.requireDatePicker = requireDatePicker
                        this.$store.commit('setScheduleBtnValidity', {
                            id: customerID,
                            status: isValid,
                            action: "add",
                            isPackage: !!product.PackageItems
                        })
                        self.$store.commit('setAgeRestrictionErrMessages', {
                            id: customerID,
                            message: ''
                        })
                        return {
                            isValid: isValid,
                            requireDatePicker: requireDatePicker
                        }
                    },
                    isValidToSchedule: function () {
                        var validationResults = _.values(this.$store.state.scheduleBtnValidityPerUser)
                        return _.every(validationResults, function (val) {
                            return val == true
                        })

                    }
                }
            })
            // Vue.directive('click-outside', {
            //     bind: function (el, binding, vnode) {
            //         this.event = function (event) {
            //         if (!(el == event.target || el.contains(event.target))) {
            //             vnode.context[binding.expression](event);
            //         }
            //         };
            //         document.body.addEventListener('click', this.event)
            //     },
            //     unbind: function (el) {
            //         document.body.removeEventListener('click', el.clickOutsideEvent)
            //     },
            // });
            Vue.directive('click-outside', {
                bind: function (el, binding, vnode) {
                    var vm = vnode.context;
                    var callback = binding.value;
                    el.clickOutsideEvent = function (event) {
                        if (!(el == event.target || el.contains(event.target))) {
                            return callback.call(vm, event);
                        }
                    };
                    document.body.addEventListener('click', el.clickOutsideEvent);
                },
                unbind: function (el) {
                    document.body.removeEventListener('click', el.clickOutsideEvent);
                },

            });
            require(['vue!app/views/vue/app', 'app/views/vue/store/store'], function (vueApp, store) {
                // if(!!urlConfig.activeStep){
                //     store.commit('setActiveStep',{step:urlConfig.activeStep,doNotUpdate:true});
                // }

                // if(!!urlConfig.date){
                //     var date = moment(urlConfig.date,'YYYY-MM-DD').format(localStrings.stepper.body.schedule.dateBarDaysFormat)
                //     store.commit('setselectedDateOnDateBar',{date:date,doNotUpdate:true});
                // }
                var vm1 = new Vue({
                    el: '#vue-app',
                    store: store,
                    beforeMount: function () {
                        if (app.data.resetVueApp) {
                            app.datal('resetVueApp', false);
                            store.commit('setActiveStep', 0)
                        }
                    },
                    // function(h){ return h(vueApp)
                    render: function (h) {
                        return h(vueApp)
                    }
                });
                app.datal('vueAppRef', vm1);
            });
        }
    }
);
